"use client";
import { stripTags } from "@/helpers/common";
import { renderToStaticMarkup } from "react-dom/server";
import { EditorContent } from "@/components/pages/article/EditorContent";
import { EditorContentData } from "@/components/pages/article/EditorContent/types";

export const getBioContent = (bio: EditorContentData) =>
  stripTags(renderToStaticMarkup(<EditorContent data={bio} />));
